import styled from 'styled-components'

export interface IDescriptionItemValueStyledProps {
  padding?: 'none' | 'default'
}

export const DescriptionItemValueStyled = styled.div<IDescriptionItemValueStyledProps>`
  && {
    ${(props) => {
      if (props.padding === 'none') {
        return `
        padding-top: 0;
        padding-bottom: 0;
      `
      }
    }}
  }
`
